'use strict';

export default {
  methods: {
    obtenerEntidadesParametrica () {
      return new Promise((resolve, reject) => {
        this.$service.get(`entidades`, {}).then(response => {
          if (response) {
            resolve({ datos: response, finalizado: true });
          }
        }).catch(error => {
          console.error(error);
          reject(new Error('Error en parametrica ' + error));
        });
      });
    },
    obtenerTipoCargoParametrica () {
      return new Promise((resolve, reject) => {
        this.$service.get(`tipos_cargo`, {}).then(response => {
          if (response) {
            resolve({ datos: response, finalizado: true });
          }
        }).catch(error => {
          console.error(error);
          reject(new Error('Error en parametrica ' + error));
        });
      });
    },
    obtenerTipoFuncionesParametrica () {
      return new Promise((resolve, reject) => {
        this.$service.get(`tipos_funciones`, {}).then(response => {
          if (response) {
            resolve({ datos: response, finalizado: true });
          }
        }).catch(error => {
          console.error(error);
          reject(new Error('Error en parametrica ' + error));
        });
      });
    },
    obtenerDepartamentosParametrica () {
      return new Promise((resolve, reject) => {
        this.$service.get(`departamentos`, {}).then(response => {
          if (response) {
            resolve({ datos: response, finalizado: true });
          }
        }).catch(error => {
          console.error(error);
          reject(new Error('Error en parametrica ' + error));
        });
      });
    },
    obtenerTipoAdquisicionParametrica () {
      return new Promise((resolve, reject) => {
        this.$service.get(`tipos_adquisicion`, {}).then(response => {
          if (response) {
            resolve({ datos: response, finalizado: true });
          }
        }).catch(error => {
          console.error(error);
          reject(new Error('Error en parametrica ' + error));
        });
      });
    },
    obtenerMotivoDeclaracionParametrica () {
      return new Promise((resolve, reject) => {
        this.$service.get(`motivos_declaracion`, {}).then(response => {
          if (response) {
            resolve({ datos: response, finalizado: true });
          }
        }).catch(error => {
          console.error(error);
          reject(new Error('Error en parametrica ' + error));
        });
      });
    },
    obtenerPaisesParametrica () {
      return new Promise((resolve, reject) => {
        this.$service.get(`paises`, {}).then(response => {
          if (response) {
            resolve({ datos: response, finalizado: true });
          }
        }).catch(error => {
          console.error(error);
          reject(new Error('Error en parametrica ' + error));
        });
      });
    },
    obtenerTiposNacionalidadParametrica () {
      return new Promise((resolve, reject) => {
        this.$service.get(`tipos_nacionalidad`, {}).then(response => {
          if (response) {
            resolve({ datos: response, finalizado: true });
          }
        }).catch(error => {
          console.error(error);
          reject(new Error('Error en parametrica ' + error));
        });
      });
    },
    obtenerEstadosCivilesParametrica () {
      return new Promise((resolve, reject) => {
        this.$service.get(`estados_civiles`, {}).then(response => {
          if (response) {
            resolve({ datos: response, finalizado: true });
          }
        }).catch(error => {
          console.error(error);
          reject(new Error('Error en parametrica ' + error));
        });
      });
    },
    obtenerTiposDeudaParametrica () {
      return new Promise((resolve, reject) => {
        this.$service.get(`tipos_deudas`, {}).then(response => {
          if (response) {
            resolve({ datos: response, finalizado: true });
          }
        }).catch(error => {
          console.error(error);
          reject(new Error('Error en parametrica ' + error));
        });
      });
    },
    obtenerEstadoDeclaracion () {
      return new Promise((resolve, reject) => {
        this.$service
        .get(`djbr_registro/obtiene_estado`, {})
        .then(response => {
          this.$storage.set('ex', response.cod_estado);
          resolve({ data: response, finalizado: true });
        }).catch(error => {
          console.error(error);
          reject(new Error('Error en parametrica ' + error));
        });
      });
    },
    obtenerEstadoCivil () {
      return new Promise((resolve, reject) => {
        this.$service
        .get(`djbr_registro/datos_declarante`, {})
        .then(response => {
          this.$storage.set('estado_civil', response.estciv_codigo);
          resolve({ data: response, finalizado: true });
        }).catch(error => {
          console.error(error);
          reject(new Error('Error en parametrica ' + error));
        });
      });
    },
    obtenerDatosStorage () {
      return new Promise((resolve, reject) => {
        if (this.$storage.exist('user')) {
          this.usuario = this.$storage.get('user');
        }
      });
    },
    navBarEmmit () {
      this.$root.$emit('clickedSomething');
    },
    EstCivEmmit () {
      this.$root.$emit('clickedEstCivil');
    },
    StorageEmmit () {
      this.$root.$emit('clickedNavBar');
    },
    datosDeclaracionEmmit () {
      this.$root.$emit('clickedDatosDeclaracion');
    },
    guardarDatosDeclaracionEmmit () {
      this.$root.$emit('clickedGuardarDatosDeclaracion');
    },
    guardarDatosPersonalesEmmit () {
      this.$root.$emit('clickedGuardarDatosPersonales');
    },
    guardarCargoOcuparaEmmit () {
      this.$root.$emit('clickedGuardarDatosCargoOcupara');
    },
    guardarConyugeEmmit () {
      this.$root.$emit('clickedGuardarConyugue');
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/djbrd/mixins/parametricas.js